/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OemPartnerGroupDto } from './OemPartnerGroupDto';
import {
    OemPartnerGroupDtoFromJSON,
    OemPartnerGroupDtoFromJSONTyped,
    OemPartnerGroupDtoToJSON,
    OemPartnerGroupDtoToJSONTyped,
} from './OemPartnerGroupDto';

/**
 * 
 * @export
 * @interface ListOemsResponseDto
 */
export interface ListOemsResponseDto {
    /**
     * 
     * @type {Array<OemPartnerGroupDto>}
     * @memberof ListOemsResponseDto
     */
    items: Array<OemPartnerGroupDto>;
    /**
     * 
     * @type {number}
     * @memberof ListOemsResponseDto
     */
    partnerCount: number;
    /**
     * 
     * @type {number}
     * @memberof ListOemsResponseDto
     */
    activeRateCount: number;
}

/**
 * Check if a given object implements the ListOemsResponseDto interface.
 */
export function instanceOfListOemsResponseDto(value: object): value is ListOemsResponseDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('partnerCount' in value) || value['partnerCount'] === undefined) return false;
    if (!('activeRateCount' in value) || value['activeRateCount'] === undefined) return false;
    return true;
}

export function ListOemsResponseDtoFromJSON(json: any): ListOemsResponseDto {
    return ListOemsResponseDtoFromJSONTyped(json, false);
}

export function ListOemsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListOemsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(OemPartnerGroupDtoFromJSON)),
        'partnerCount': json['partnerCount'],
        'activeRateCount': json['activeRateCount'],
    };
}

export function ListOemsResponseDtoToJSON(json: any): ListOemsResponseDto {
    return ListOemsResponseDtoToJSONTyped(json, false);
}

export function ListOemsResponseDtoToJSONTyped(value?: ListOemsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(OemPartnerGroupDtoToJSON)),
        'partnerCount': value['partnerCount'],
        'activeRateCount': value['activeRateCount'],
    };
}

